<table class="table">
  <thead>
    <tr>
      <td></td>
      <td>Total</td>
      <td>Allocated</td>
      <td>Shortage</td>
    </tr>
  </thead>
  <tbody>
    <tr *ngIf="item" [testId]="testIds.AVAILABILITY_ITEM_ROW">
      <td>
        <p>
          <strong>{{ item.label }}</strong>
        </p>
        <p><small>Item</small></p>
      </td>
      <td>{{ item.available }}</td>
      <td>{{ item.allocated }}</td>
      <td class="text-red-500 font-bold">
        {{
          item.available - item.allocated < 0
            ? (item.available - item.allocated) * -1
            : '-'
        }}
      </td>
    </tr>
    <tr *ngIf="product" [testId]="testIds.AVAILABILITY_PRODUCT_ROW">
      <td>
        <p>
          <strong>{{ product.label }}</strong>
        </p>
        <p><small>Product</small></p>
      </td>
      <td>{{ product.available }}</td>
      <td>{{ product.allocated }}</td>
      <td class="text-red-500 font-bold">
        {{
          product.available - product.allocated < 0
            ? (product.available - product.allocated) * -1
            : '-'
        }}
      </td>
    </tr>
    <tr *ngIf="category" [testId]="testIds.AVAILABILITY_CATEGORY_ROW">
      <td>
        <p>
          <strong>{{ category.label }}</strong>
        </p>
        <p><small>Category</small></p>
      </td>
      <td>{{ category.available }}</td>
      <td>{{ category.allocated }}</td>
      <td class="text-red-500 font-bold">
        {{
          category.available - category.allocated < 0
            ? (category.available - category.allocated) * -1
            : '-'
        }}
      </td>
    </tr>
  </tbody>
</table>
